import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { jwtDecode } from 'jwt-decode';
import { Reclamation } from '../../modules/reclamation/models/reclamation';
import { User } from 'src/app/modules/auth/models/user.model';
import { Router } from '@angular/router';
const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
@Injectable({ providedIn: 'root' })
export class DelaisService {
  private apiUrls: { [key in 'bank' | 'pgl' | 'smt']: string } = {
    bank: environment.apiBankUrl, 
    pgl: environment.apiPglUrl,
    smt: environment.apiSmtUrl,
  };
  private getBaseUrl(): string {
    const userType = this.getUserType();
    return this.apiUrls[userType??'smt']+'/reclamations/';
  }
  private getUserType(): 'bank' | 'pgl' | 'smt' {
    const token = localStorage.getItem('x-access-token') || ''; // Fallback to an empty string if null
    if (!token) return 'smt';

    try {
      const decodedToken: any = jwtDecode(token);
      return decodedToken.type as 'bank' | 'pgl' | 'smt';
    } catch (error) {
      console.error('Error decoding token:', error);
      return 'smt';
    }
  } 
    constructor(private router:Router)
    {}
    calculatereturnedandremainingdays(daterepresentation: number, parameter: number,currentdate:number) {
        const MS_PER_DAY = 24 * 60 * 60 * 1000;
      
        const normalizeToMidnight = (date: number): number => {
          const d = new Date(date);
          return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
        };
      
        const normalizedDateRepresentation = normalizeToMidnight(daterepresentation);
        const returnedDate = normalizedDateRepresentation + parameter * MS_PER_DAY;
        const normalizedCurrentDate = normalizeToMidnight(currentdate);
        const remainingDays = Math.max(0, Math.ceil((returnedDate - normalizedCurrentDate) / MS_PER_DAY));
      
        return { returneddate: returnedDate, remainingdays: remainingDays };
      }
    getspecificstatus(rec: Reclamation, rank:number): any
      {
    //@ts-ignore
    const allstatus = rec.statut.filter(e => !e.etat);
    const specifcistatus= allstatus[(allstatus.length)-rank]
    //@ts-ignore
    return specifcistatus
      }
    calculatedeadline(rec: Reclamation,currentdate: number,motifs:any): any {
        //@ts-ignore
        const allstatus = rec.statut.filter(e => !e.etat);
        //@ts-ignore
        const transaction = rec.transactions[0]
        let remainingdays = 1, returneddate: any;
        const getStatusDate = (item: string, role?: string): number => {
              //@ts-ignore
          const status = allstatus.find(s => s.item === item && (!role || s.role === role));
              //@ts-ignore
          return status ? status.date : currentdate;
        };
      
        const calculateDays = (statusItem: string, motifProp: keyof any) => {
          const date = getStatusDate(statusItem?.toString());
          const days = motifs[0]?.[motifProp] || 1;
          return this.calculatereturnedandremainingdays(date, days,currentdate);
        };
      
        if (allstatus.length > 0) {
              //@ts-ignore
          const lastStatusItem = allstatus[allstatus.length - 1].item;
                //@ts-ignore
          const previouslastStatusItem = allstatus[allstatus.length - 2]?.item;
                      //@ts-ignore
          const prepreviouslastStatusItem = allstatus[allstatus.length - 3]?.item;
                            //@ts-ignore
          const preprepreviouslastStatusItem = allstatus[allstatus.length - 4]?.item;
          //@ts-ignore
          const lastStatusrole = allstatus[allstatus.length - 1].role;
              //@ts-ignore
          const transactionCode = rec.transactions[0].TRANSACTIONCODE;
      
          if (lastStatusItem == 'crée') {
            ({ returneddate, remainingdays } = calculateDays('crée', 'creerec'));
          } 
          else if (lastStatusItem === 'rechdoc') {
            ({ returneddate, remainingdays } = calculateDays('rechdoc', 'initrech'));
          } 
          else if (lastStatusItem === 'reponserechdoc') {
            ({ returneddate, remainingdays } = calculateDays('rechdoc', 'initrech'));
          } 
          //@ts-ignore
      else if (lastStatusItem === 'rejetée'&&lastStatusrole=='émetteur') {
                ({ returneddate, remainingdays } = calculateDays('rejetée', 'relancerec'));
              }
          //@ts-ignore
          else if (lastStatusItem === 'relancée'&&transaction.ISSUERBANKIDENTIFICATION==transaction.ACQUIRERBANKIDENTIFICATION) {
            ({ returneddate, remainingdays } = calculateDays('relancée', 'relancerec'));
          }
          else if (lastStatusItem === 'chb émis') {
                //@ts-ignore
            const motif = allstatus[allstatus.length - 1].motif.substring(0, 4);
            const delai2 = motifs[0]?.groupe.find(ele => ele.code === motif)?.delai2 || 1;
      
            if (['05', '06', '07', '08'].includes(transactionCode)) {
              ({ returneddate, remainingdays } = this.calculatereturnedandremainingdays(getStatusDate('chb émis'), delai2,currentdate));
            }
          } else if (lastStatusItem === 'rejetée'&&lastStatusrole=='acquireur'||lastStatusItem === 'relancée'&&previouslastStatusItem=='rejetée'&&prepreviouslastStatusItem=='rejetée'&&preprepreviouslastStatusItem=='chb émis') {
            ({ returneddate, remainingdays } = this.calculatereturnedandremainingdays(getStatusDate('rejetée', 'acquireur'), motifs[0]?.initprearb,currentdate));
          } else if (lastStatusItem === 'pré-arbitrage') {
            ({ returneddate, remainingdays } = calculateDays('pré-arbitrage', 'repprearb'));
          } else if (lastStatusItem === 'pré-arbitrage rejetée'||lastStatusItem === 'relancée'&&previouslastStatusItem=='rejetée'&&prepreviouslastStatusItem=='pré-arbitrage rejetée') {
            ({ returneddate, remainingdays } = calculateDays('pré-arbitrage rejetée', 'initarb'));
          } else if (lastStatusItem === 'arbitrage') {
            ({ returneddate, remainingdays } = calculateDays('arbitrage', 'initcomite'));
          } else if (lastStatusItem === 'arbitrage rejeté'||lastStatusItem === 'relancée'&&previouslastStatusItem=='rejetée'&&prepreviouslastStatusItem=='arbitrage rejetée') {
            ({ returneddate, remainingdays } = calculateDays('arbitrage', 'initcomite'));
          }
          else {
            remainingdays = 0;
          }
        }
      
        return { returneddate, remainingdays };
      }
    Authorize(currentuser:User,reclamation:Reclamation,currentdate:number,motifs:any,link:any)
    {
    let id=reclamation._id
    //@ts-ignore
    let filtredstatus=reclamation.statut.filter(el=>!el.etat)
    //@ts-ignore
    let filtredetat=reclamation.statut.filter(el=>el.etat)
    //@ts-ignore
    let iss=reclamation.transactions[0].ISSUERBANKIDENTIFICATION
    //@ts-ignore
    let acq=reclamation.transactions[0].ACQUIRERBANKIDENTIFICATION
    console.log(+this.calculatedeadline(reclamation,currentdate,motifs).remainingdays)
    console.log(this.getspecificstatus(reclamation,1))
    if(currentuser.role=='superadmin')
    {
      confirm('réclamation disponible en mode consultation uniquement')?
      this.router.navigate(['reclamation/open-detail'+'/'+id+'/all']):''
    }
    else if (this.getspecificstatus(reclamation,1).item=='clôturé'/*&&this.getspecificstatus(reclamation,1).item!='encours'
    &&this.getspecificstatus(reclamation,1).item!='chb émis'&&this.getspecificstatus(reclamation,1).item!='rejetée'&&this.getspecificstatus(reclamation,2).item!='chb émis'
    &&this.getspecificstatus(reclamation,2).item!='pré-arbitrage rejetée'*/
    )
    {
    confirm('réclamation clôturée')?
    
      this.router.navigate(['reclamation/open-detail'+'/'+id+'/all']):''
    }
    else if (+this.calculatedeadline(reclamation,currentdate,motifs).remainingdays<=0&&currentuser.usertype=='Clientcomm')
    {
    alert('deadline pour traitement de la réclamation dépassé')
    }
    
    else if (+this.calculatedeadline(reclamation,currentdate,motifs).remainingdays<=0&&this.getspecificstatus(reclamation,1).item=='chb émis'/*&&this.getspecificstatus(reclamation,1).item!='encours'
    &&this.getspecificstatus(reclamation,1).item!='chb émis'&&this.getspecificstatus(reclamation,1).item!='rejetée'&&this.getspecificstatus(reclamation,2).item!='chb émis'
    &&this.getspecificstatus(reclamation,2).item!='pré-arbitrage rejetée'*/
    )
    {
    confirm('deadline pour traitement de la réclamation dépassé')?
    
      this.router.navigate(['reclamation/open-detail'+'/'+id+'/all']):''
    }
    
     else if (+this.calculatedeadline(reclamation,currentdate,motifs).remainingdays<=0&&this.getspecificstatus(reclamation,1)?.item=='rejetée'&&this.getspecificstatus(reclamation,2)?.item=='chb émis'/*&&this.getspecificstatus(reclamation,1).item!='encours'
      &&this.getspecificstatus(reclamation,1).item!='chb émis'&&this.getspecificstatus(reclamation,1).item!='rejetée'&&this.getspecificstatus(reclamation,2).item!='chb émis'
      &&this.getspecificstatus(reclamation,2).item!='pré-arbitrage rejetée'*/
      )
      {
      confirm('deadline pour traitement de la réclamation dépassé')?
      
        this.router.navigate(['reclamation/open-detail'+'/'+id+'/all']):''
      }
    
    
    else if (+this.calculatedeadline(reclamation,currentdate,motifs).remainingdays<=0&&this.getspecificstatus(reclamation,1).item=='pré-arbitrage rejetée'&&this.getspecificstatus(reclamation,1).role=='émetteur'/*&&this.getspecificstatus(reclamation,1).item!='encours'
    &&this.getspecificstatus(reclamation,1).item!='chb émis'&&this.getspecificstatus(reclamation,1).item!='rejetée'&&this.getspecificstatus(reclamation,2).item!='chb émis'
    &&this.getspecificstatus(reclamation,2).item!='pré-arbitrage rejetée'*/
    )
    {
    confirm('deadline pour traitement de la réclamation dépassé')?
    
      this.router.navigate(['reclamation/open-detail'+'/'+id+'/all']):''
    }
    else if (+this.calculatedeadline(reclamation,currentdate,motifs).remainingdays<=0&&this.getspecificstatus(reclamation,1).item=='rechdoc'||+this.calculatedeadline(reclamation,currentdate,motifs).remainingdays<=0&&this.getspecificstatus(reclamation,1).item=='reponserechdoc'/*&&this.getspecificstatus(reclamation,1).item!='encours'
    &&this.getspecificstatus(reclamation,1).item!='chb émis'&&this.getspecificstatus(reclamation,1).item!='rejetée'&&this.getspecificstatus(reclamation,2).item!='chb émis'
    &&this.getspecificstatus(reclamation,2).item!='pré-arbitrage rejetée'*/
    )
    {
    confirm('deadline pour traitement de la réclamation dépassé')?
    
      this.router.navigate(['reclamation/open-detail'+'/'+id+'/all']):''
    }
    /*else if (+this.calculatedeadline(reclamation).remainingdays<=0&&this.getspecificstatus(reclamation,1).item!='crée'&&this.getspecificstatus(reclamation,1).item!='encours'
    &&this.getspecificstatus(reclamation,1).item!='chb émis'&&this.getspecificstatus(reclamation,1).item!='rejetée'&&this.getspecificstatus(reclamation,2).item!='chb émis'
    &&this.getspecificstatus(reclamation,2).item!='pré-arbitrage rejetée'
    )
    {
    confirm('deadline pour traitement de la réclamation dépassé')?
    
      this.router.navigate(['reclamation/open-detail'+'/'+id+'/all']):''
    }*/
     else if(currentuser.usertype=='Clientpor')
        {
          if(filtredstatus.length>1)
          {
            //@ts-ignore
            if(filtredstatus[filtredstatus.length-1].item=='rejetée'&&filtredstatus[filtredstatus.length-2].item=='rejetée'||
            //@ts-ignore
            filtredstatus[filtredstatus.length-1].item=='rejetée'&&filtredstatus[filtredstatus.length-2].item=='pré-arbitrage rejetée'||
            //@ts-ignore
            filtredstatus[filtredstatus.length-1].item=='rejetée'&&filtredstatus[filtredstatus.length-2].item=='pré-arbitrage'||
            //@ts-ignore
            filtredstatus[filtredstatus.length-1].item=='rejetée'&&filtredstatus[filtredstatus.length-2].item=='crée'
            //@ts-ignore
            ||filtredstatus[filtredstatus.length-1].item=='rejetée'&&filtredstatus[filtredstatus.length-2].item=='reponserechdoc')
            {
              this.router.navigate([link + '/' + id]);; 
            }
              //@ts-ignore
            else  if(filtredstatus[filtredstatus.length-1].item=='clôturé')
              {
                return (alert('Action impossible - réclamation clôturée')) 
              }
                //@ts-ignore
            else  if(filtredstatus[filtredstatus.length-1].item=='acceptée'||filtredstatus[filtredstatus.length-1].item=='arbitrage accepté'||filtredstatus[filtredstatus.length-1].item=='Arbitrage fav. émetteur')
            {
              return (alert('Action impossible - réclamation traitée')) 
            }
            //@ts-ignore
            else
            {
        return (alert('À ce stade, vous ne pouvez pas effectuer cette action. Actuellement, vous avez la possibilité de consulter l\’historique et d’ajouter des notes.'))     
            }
          }
          else
          {
            return (alert('À ce stade, vous ne pouvez pas effectuer cette action. Actuellement, vous avez la possibilité de consulter l’historique et d’ajouter des notes.'))     
          }
        }
     else  if(currentuser.usertype=='Clientcomm')
        {
          if(filtredetat.length>0)
          {
            //@ts-ignore
            if(filtredetat[filtredetat.length-1].etat=='notification commerçant')
            {
              this.router.navigate([link + '/' + id]); 
            }
              //@ts-ignore
            else  if(filtredstatus[filtredstatus.length-1].item=='clôturé')
              {
                return (alert('Action impossible - réclamation clôturée')) 
              }
                //@ts-ignore
            else  if(filtredstatus[filtredstatus.length-1].item=='acceptée'||filtredstatus[filtredstatus.length-1].item=='arbitrage accepté'||filtredstatus[filtredstatus.length-1].item=='Arbitrage fav. émetteur')
            {
              return (alert('Action impossible - réclamation traitée')) 
            }
            //@ts-ignore
            else
            {
        return (alert('À ce stade, vous ne pouvez pas effectuer cette action. Actuellement, vous avez la possibilité de consulter l’historique et d’ajouter des notes.'))     
            }
          }
          else
          {
            return (alert('À ce stade, vous ne pouvez pas effectuer cette action. Actuellement, vous avez la possibilité de consulter l’historique et d’ajouter des notes.'))     
          }
        }
     else  if(currentuser.usertype=='comite arbitrage')
        {
          if(filtredstatus.length>1)
          {
     
            //@ts-ignore
            if(filtredstatus[filtredstatus.length-1].item=='arbitrage'&&filtredstatus[filtredstatus.length-1].date+(motifs[0]?.repacquireur*24*3600*1000)<new Date().getTime()||filtredstatus[filtredstatus.length-1].item=='arbitrage rejeté')
            {
              this.router.navigate([link + '/' + id]); 
            }
              //@ts-ignore
            else  if(filtredstatus[filtredstatus.length-1].item=='arbitrage'&&filtredstatus[filtredstatus.length-1].date+(motifs[0]?.repacquireur*24*3600*1000)>new Date().getTime())
              {
                
                return (confirm('Action impossible - en attente de la réponse de la banque')?
                this.router.navigate(['reclamation/open-detail'+'/'+id+'/all']):'') 
              }
            //@ts-ignore
            else
            {
        return (confirm('À ce stade, vous ne pouvez pas effectuer cette action. Actuellement, vous avez la possibilité de consulter l’historique et d’ajouter des notes')?
        this.router.navigate(['reclamation/open-detail'+'/'+id+'/all']):'')     
            }
          }
          else
          {
            return (confirm('À ce stade, vous ne pouvez pas effectuer cette action. Actuellement, vous avez la possibilité de consulter l’historique et d’ajouter des notes')?
            this.router.navigate(['reclamation/open-detail'+'/'+id+'/all']):'')     
          }
        }
     else {
          if(iss!=acq)
          {
            if(currentuser.banque==iss)
            {
    //@ts-ignore
    if(filtredstatus[filtredstatus.length-1].role=='émetteur'&&filtredstatus[filtredstatus.length-1].item!='crée'&&filtredstatus[filtredstatus.length-1].item!='arbitrage rejeté')
                      {
                        confirm('À ce stade, vous ne pouvez pas effectuer cette action. Actuellement, vous avez la possibilité de consulter l’historique et d’ajouter des notes')?
                        this.router.navigate(['reclamation/open-detail'+'/'+id+'/all']):''
                      }
    //@ts-ignore
    else if(filtredstatus[filtredstatus.length-1].item=='arbitrage rejeté')
                    {
                      confirm('réclamation en cours de traitement par le comité d\'arbitrage')?
                      this.router.navigate(['reclamation/open-detail'+'/'+id+'/all']):''
                    }
    
    /*else if(reclamation.statut.length>1)
    {
      if(reclamation.statut[reclamation.statut.length-2].item=='relancée'&&reclamation.statut[reclamation.statut.length-1].item=='pré-arbitrage')
                      {
                        confirm('À ce stade, vous ne pouvez pas effectuer cette action. Actuellement, vous avez la possibilité de consulter l’historique et d’ajouter des notes')?
                        this.router.navigate(['reclamation/open-detail'+'/'+id+'/all']):''
                      }
                      else
                      {
                        this.router.navigate([link + '/' + id]); 
    
                      }
    }*/
    
                      else
                      {
                        this.router.navigate([link + '/' + id]);
    
                      }
            }
            else  if(currentuser.banque==acq)
            {
    // this.reclamationsacq=reclamations.filter(e=>e.statut.length>0).filter(e=>e.statut[e.statut.length-1].item=='chb émis'||e.statut[e.statut.length-1].item=='pré-arbitrage')
    //@ts-ignore
    if(filtredstatus[filtredstatus.length-1].role=='acquireur'&&filtredstatus[filtredstatus.length-1].item!='arbitrage rejeté'
    //@ts-ignore
    ||filtredstatus[filtredstatus.length-1].item=='relancée')
                      {
                        
                        confirm('À ce stade, vous ne pouvez pas effectuer cette action. Actuellement, vous avez la possibilité de consulter l’historique et d’ajouter des notes')?
                        this.router.navigate(['reclamation/open-detail'+'/'+id+'/all']):''
                      }
                          //@ts-ignore
    else if(filtredstatus[filtredstatus.length-1].item=='arbitrage rejeté')
    {
      confirm('réclamation en cours de traitement par le comité d\'arbitrage')?
      this.router.navigate(['reclamation/open-detail'+'/'+id+'/all']):''
    }
    /*else if(reclamation.statut[reclamation.statut.length-1].item=='arbitrage rejeté')
                    {
                      confirm('réclamation en cours de traitement par le comité d\'arbitrage')?
                      this.router.navigate(['reclamation/open-detail'+'/'+id+'/all']):''
                    }*/
    /*else if(reclamation.statut.length>1)
    {
      if(reclamation.statut[reclamation.statut.length-2].item=='relancée'&&reclamation.statut[reclamation.statut.length-1].item=='pré-arbitrage')
                      {
                        confirm('À ce stade, vous ne pouvez pas effectuer cette action. Actuellement, vous avez la possibilité de consulter l’historique et d’ajouter des notes')?
                        this.router.navigate(['reclamation/open-detail'+'/'+id+'/all']):''
                      }
                      else
                      {
                        this.router.navigate([link + '/' + id]); 
    
                      }
    }*/
    //@ts-ignore
    else if(filtredstatus[filtredstatus.length-1].item=='chb émis'&&filtredstatus[filtredstatus.length-2].item=='rechdoc'&&motifsrechdoc.find(e=>e.code==filtredstatus[filtredstatus.length-1].motif.substring(0, 4)&&e.rechdocpresentation=='NON'))
    {
      alert('vous avez dépasser la limite pour représenter ce chargeback')
    }
                      else
                      {
                        this.router.navigate([link + '/' + id]); 
    
                      }
            }
            else{
              this.router.navigate([link + '/' + id]); 
    
            }
          }
          else{
            this.router.navigate([link + '/' + id]); 
    
          }
        }
     
      }

}
